import React, { useState, useEffect } from "react";
import { Loader2, X, AlertCircle, CheckCircle2 } from "lucide-react";
import axios from "axios";
import CalendarInput from "../calendarInput";
import { useLocation } from "react-router-dom";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const HandleEntry = ({
  showEntryModal,
  hasPayoutGen,
  hasPayoutApproval,
   selectedStatus,
  setShowEntryModal,
  selectedRecord,
  selectedCompany,
  currentPage,
  fetchAttendanceData,
  showentrymarkdays,
  setshowentrymarkdays

}) => {
  const [entryDate, setEntryDate] = useState("");
  const [entryTimeInput, setEntryTimeInput] = useState({ hours: "", minutes: "", period: "AM" });
  const [busEntry, setBusEntry] = useState(false);
  const [entryTimeError, setEntryTimeError] = useState("");
const [searchTab, setSearchTab] = useState("phone"); // "phone" | "emp"
const [empCodeInput, setEmpCodeInput] = useState("");
  const [phoneInput, setPhoneInput] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [workerError, setWorkerError] = useState("");
  const [workerDetails, setWorkerDetails] = useState(null);
  const [mappedDepartments, setMappedDepartments] = useState([]);
  // FIX: store full mapped department objects for _id lookup (matches original)
  const [mappedDepartmentsData, setMappedDepartmentsData] = useState([]);
  const [workerSkills, setWorkerSkills] = useState("");
  const [selectedEntryDepartment, setSelectedEntryDepartment] = useState("");

  const [loading, setLoading] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const path = window.location.pathname;

  // Destructure for easy access
  const workerData = selectedRecord?.data || null;
  const attendance = selectedRecord?.attendance || null;

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const isPayoutFilePage =location.pathname === "/lkart/superadmin/payout-file" 

  const getAllowedDates = () => {
    const today = new Date();
    const sevenDaysAgo = new Date(today);
    sevenDaysAgo.setDate(sevenDaysAgo.getDate()-showentrymarkdays);
    return {
      today: today.toISOString().split("T")[0],
      yesterday: sevenDaysAgo.toISOString().split("T")[0],
    };
  };
  const { today, yesterday } = getAllowedDates();

  // Pre-fill when editing existing record
  useEffect(() => {
    if (showEntryModal && attendance) {
      if (attendance.EntryDate) {
        setEntryDate(attendance.EntryDate.split("T")[0]);
        const timePart = attendance.EntryDate.split("T")[1]?.split(".")[0];
        if (timePart) {
          const [hours, minutes] = timePart.split(":");
          let hourNum = parseInt(hours);
          const period = hourNum >= 12 ? "PM" : "AM";
          if (hourNum > 12) hourNum -= 12;
          else if (hourNum === 0) hourNum = 12;
          setEntryTimeInput({ hours: hourNum.toString(), minutes, period });
        }
      }
      setBusEntry(attendance.busEntry || false);
      setEntryTimeError("");
    }
  }, [showEntryModal, attendance]);

  // Default date for new entry
  useEffect(() => {
    if (showEntryModal && !selectedRecord) {
      setEntryDate(new Date().toISOString().split("T")[0]);
    }
  }, [showEntryModal, selectedRecord]);

  const convertTo24HourWithSeconds = (hours, minutes, period) => {
    let hourNum = parseInt(hours);
    if (period === "AM" && hourNum === 12) hourNum = 0;
    else if (period === "PM" && hourNum !== 12) hourNum += 12;
    return `${hourNum.toString().padStart(2, "0")}:${minutes.padStart(2, "0")}:00`;
  };

  const closeModal = () => {
    setShowEntryModal(false);
    setBusEntry(false);
    setWorkerDetails(null);
    setPhoneInput("");
    setEmpCodeInput("");
    setPhoneError("");
    setWorkerError("");
    setEntryDate("");
    setEntryTimeInput({ hours: "", minutes: "", period: "AM" });
    setSelectedEntryDepartment("");
    setMappedDepartments([]);
    setMappedDepartmentsData([]);
    setWorkerSkills("");
    setEntryTimeError("");
  };

  const handleEntryTimeChange = (e) => {
    const { name, value } = e.target;
    if (name === "hours" && value !== "") {
      const num = parseInt(value);
      if (isNaN(num) || num < 1 || num > 12) return;
    }
    if (name === "minutes" && value !== "") {
      const num = parseInt(value);
      if (isNaN(num) || num < 0 || num > 59) return;
    }
    setEntryTimeInput((prev) => ({ ...prev, [name]: value }));
    if (entryTimeError) setEntryTimeError("");
  };

  const handleEntryDateChange = (value) => {
    setEntryDate(value);
    if (entryTimeError) setEntryTimeError("");
  };

  // FIX: matches original — for edit mode checks 7-day window from today;
  // for new entry mode only checks not-in-future
const validateEntryDateTime = () => {
  if (!entryDate || !entryTimeInput.hours || !entryTimeInput.minutes) return false;

  const time24h = convertTo24HourWithSeconds(
    entryTimeInput.hours,
    entryTimeInput.minutes.padStart(2, "0"),
    entryTimeInput.period
  );
  const now = new Date();
  const todayStr = now.toISOString().split("T")[0];

  // For new entries — only check not-in-future
  if (!selectedRecord) {
    if (entryDate === todayStr) {
      const currentTime24h = `${now.getHours().toString().padStart(2, "0")}:${now.getMinutes().toString().padStart(2, "0")}:00`;
      if (time24h > currentTime24h) {
        setEntryTimeError("Entry time cannot be in the future");
        return false;
      }
    }
    setEntryTimeError("");
    return true;
  }

  // For editing existing entries
  if (attendance?.EntryDate) {
    // Normalize all dates to midnight to avoid time-component issues
    const originalDateOnly = new Date(attendance.EntryDate);
    originalDateOnly.setHours(0, 0, 0, 0);

    const selectedDate = new Date(entryDate);
    selectedDate.setHours(0, 0, 0, 0);

    const todayDate = new Date();
    todayDate.setHours(0, 0, 0, 0);

    // Lower bound: 7 days before original entry date
    const lowerBound = new Date(originalDateOnly);
    lowerBound.setDate(lowerBound.getDate() - showentrymarkdays);

    // Upper bound: 7 days after original entry, but capped at today
    const sevenDaysAfter = new Date(originalDateOnly);
    sevenDaysAfter.setDate(sevenDaysAfter.getDate() + 7);
    const upperBound = sevenDaysAfter < todayDate ? sevenDaysAfter : todayDate;

    if (selectedDate < lowerBound || selectedDate > upperBound) {
      setEntryTimeError(
        `Entry date must be within ${showentrymarkdays} days before or after the original entry date`
      );
      return false;
    }

    // If selected date is today, ensure time is not in the future
    if (entryDate === todayStr) {
      const currentTime24h = `${now.getHours().toString().padStart(2, "0")}:${now.getMinutes().toString().padStart(2, "0")}:00`;
      if (time24h > currentTime24h) {
        setEntryTimeError("Entry time cannot be in the future");
        return false;
      }
    }
  }

  setEntryTimeError("");
  return true;
};

  // FIX: original uses /^[1-9]\d{9}$/ — allows any non-zero first digit
  const validatePhoneNumber = (phone) => {
    const phoneRegex = /^[1-9]\d{9}$/;
    if (!phone) { setPhoneError("Please enter a phone number"); return false; }
    if (!phoneRegex.test(phone)) { setPhoneError("Invalid phone number."); return false; }
    setPhoneError("");
    return true;
  };

  const resetWorkerState = () => {
    setWorkerDetails(null);
    setMappedDepartments([]);
    setMappedDepartmentsData([]);
    setWorkerSkills("");
    setSelectedEntryDepartment("");
  };

  const handleCheckPhone = async () => {
    // Validation based on active tab
    if (searchTab === "phone") {
      if (!validatePhoneNumber(phoneInput)) return;
    } else {
      if (!empCodeInput.trim()) return;
    }

  try {
    setLoading(true);
    setWorkerError("");



const token = path.startsWith("/lkart/admin")
  ? localStorage.getItem("admin_auth_token")
  : path.startsWith("/lkart/superadmin")
    ? localStorage.getItem("superadmintoken")
    : null;

    // Build payload based on active tab
    const payload =
      searchTab === "phone"
        ? { phone: phoneInput, companyId: selectedCompany }
        : { workerCode: empCodeInput.trim(), companyId: selectedCompany };

    const response = await axios.post(
      `${BASE_URL}/lenskart-admin/phone-details`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

      if (response.data.success) {
        const worker = response.data.data;
        setWorkerDetails({
          name: worker.name,
          department: worker.department,
          departmentId: worker.departmentId || null,
          userId: worker._id,
        });
        setshowentrymarkdays(worker.EntryMarkedForPreviousDays);

        // Only mapped departments are shown (worker.department is not included)
        const departmentNames = worker.mappedDepartments?.map((d) => d.department) || [];
        setMappedDepartments(departmentNames);
        setMappedDepartmentsData(worker.mappedDepartments || []);
        setWorkerSkills(worker.skills?.join(", ") || "No skills listed");
        // Start with no selection so the user must choose a department
        setSelectedEntryDepartment("");
      } else {
        setWorkerError(
          searchTab === "phone"
            ? "Worker not found for this phone number"
            : "Worker not found for this worker code"
        );
        resetWorkerState();
      }
    } catch {
      setWorkerError(
        searchTab === "phone"
          ? "Worker not found for this phone number"
          : "Worker not found for this worker code"
      );
      resetWorkerState();
    } finally {
      setLoading(false);
    }
  };

  const handleEntryUpdate = async () => {
    if (!entryTimeInput.hours || !entryTimeInput.minutes) {
      setErrorMessage("Please enter both hours and minutes"); setShowErrorModal(true); return;
    }
    if (!entryDate) {
      setErrorMessage("Please select an entry date"); setShowErrorModal(true); return;
    }

    // FIX: validate entry date is within last 7 days from current date (original logic)
    const currentDate = new Date();
    const selectedEntryDate = new Date(entryDate);
    const sevenDaysAgo = new Date(currentDate);
    sevenDaysAgo.setDate(currentDate.getDate() - 7);

    currentDate.setHours(23, 59, 59, 999);
    selectedEntryDate.setHours(0, 0, 0, 0);
    sevenDaysAgo.setHours(0, 0, 0, 0);

    // if (selectedEntryDate > currentDate || selectedEntryDate < sevenDaysAgo) {
    //   setErrorMessage("Entry date can only be modified for the previous 7 days from today");
    //   setShowErrorModal(true);
    //   return;
    // }
    if (!validateEntryDateTime()) return;

    try {
      setLoading(true);

const token = path.startsWith("/lkart/admin")
  ? localStorage.getItem("admin_auth_token")
  : path.startsWith("/lkart/superadmin")
    ? localStorage.getItem("superadmintoken")
    : null;

    
      const time24h = convertTo24HourWithSeconds(
        entryTimeInput.hours,
        entryTimeInput.minutes.padStart(2, "0"),
        entryTimeInput.period
      );
      const entryDateTime = new Date(`${entryDate}T${time24h}.000Z`).toISOString();
      let editInsidePayoutFileBy;

if (selectedStatus=="Payout Generator") {
  editInsidePayoutFileBy = "file_generator";
} else if (selectedStatus="Payout Approver") {
  editInsidePayoutFileBy = "file_Approver";
}
      const response = await axios.post(
        `${BASE_URL}/lenskart-admin/update-entry`,
        {
          // FIX: use attendance._id as attendanceId — matches original's selectedRecord.attendanceId
          attendanceId: attendance._id,
          entryDate: entryDateTime,
          busEntry,
          companyId: selectedCompany,
          ...(isPayoutFilePage && { editInsidePayoutFile: true , editInsidePayoutFileBy })

        },
        { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } }
      );
if (response.data.success) {
  setErrorMessage("Entry time has been updated successfully");
  setShowSuccessModal(true);
  closeModal();
fetchAttendanceData(currentPage, false);
} else {
        setErrorMessage(response.data.message || "Failed to update entry time");
        setShowErrorModal(true);
      }
    } catch (error) {
      setErrorMessage(error.response?.data?.message || "Error updating entry time. Please try again.");
      setShowErrorModal(true);
    } finally {
      setLoading(false);
    }
  };

  // FIX: send departmentId in payload — mapped dept _id if available,
  // else fallback to workerDetails.departmentId (matches original exactly)
  const handleEntrySubmit = async () => {
    if (!entryTimeInput.hours || !entryTimeInput.minutes) {
      setErrorMessage("Please enter both hours and minutes"); setShowErrorModal(true); return;
    }
    if (!entryDate) {
      setErrorMessage("Please select an entry date"); setShowErrorModal(true); return;
    }
    if (!selectedEntryDepartment) {
      setErrorMessage("Please select a department"); setShowErrorModal(true); return;
    }
    if (!validateEntryDateTime()) return;

    try {
      setLoading(true);

      const token = path.startsWith("/lkart/admin")
  ? localStorage.getItem("admin_auth_token")
  : path.startsWith("/lkart/superadmin")
    ? localStorage.getItem("superadmintoken")
    : null;

      const time24h = convertTo24HourWithSeconds(
        entryTimeInput.hours,
        entryTimeInput.minutes.padStart(2, "0"),
        entryTimeInput.period
      );
      const entryDateTime = new Date(`${entryDate}T${time24h}.000Z`).toISOString();

      // FIX: look up _id from mappedDepartmentsData; fall back to workerDetails.departmentId
      const selectedMappedDept = mappedDepartmentsData.find(
        (d) => d.department === selectedEntryDepartment
      );
      const payload = {
        busEntry,
        companyId: selectedCompany,
        date: entryDate,
        department: selectedEntryDepartment,
        departmentId: selectedMappedDept?._id,
        entryTime: entryDateTime,
        status: "entry",
        userId: workerDetails.userId,
        ...(isPayoutFilePage && { editInsidePayoutFile: true }),
      };

      const response = await axios.post(
        `${BASE_URL}/lenskart-admin/mark-entry-exit`,
        payload,
        { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } }
      );
      if (response.data.success) {
        setErrorMessage("Entry time has been marked successfully");
        setShowSuccessModal(true);
        closeModal();
      } else {
        setErrorMessage(response.data.message || "Failed to record entry time");
        setShowErrorModal(true);
      }
    } catch (error) {
      setErrorMessage(error.response?.data?.message || "Error recording entry time. Please try again.");
      setShowErrorModal(true);
    } finally {
      setLoading(false);
    }
  };


  return (
    <>
      {/* Entry Modal */}
      {showEntryModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1000]">
          <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4 max-h-[90vh] overflow-y-auto">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-semibold">
                {selectedRecord ? "Modify Entry Time" : "Mark Entry Time"}
              </h3>
              <X className="h-5 w-5 cursor-pointer text-gray-500 hover:text-gray-700" onClick={closeModal} />
            </div>

            {loading ? (
              <div className="flex justify-center items-center py-8">
                <Loader2 className="h-8 w-8 animate-spin" />
              </div>
            ) : selectedRecord ? (
              /* ── EDIT EXISTING ENTRY ── */
              <div className="mb-6">
                <div className="mb-4">
                  <p className="text-sm text-gray-600">Worker Name: <span className="font-medium">{workerData?.name}</span></p>
{workerData?.workerCode && (
  <p className="text-sm text-gray-600">
    Worker Code: <span className="font-medium">{workerData.workerCode}</span>
  </p>
)}
                  <p className="text-sm text-gray-600">Phone: <span className="font-medium">{workerData?.phone}</span></p>
                  <p className="text-sm text-gray-600">Department: <span className="font-medium">{attendance?.department}</span></p>
                </div>

                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-1">Entry Date</label>
                  <CalendarInput value={entryDate} onChange={handleEntryDateChange} min={yesterday} max={today}  />
                </div>

                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-1">Entry Time</label>
                  <div className="flex items-center gap-2">
                    <input type="number" name="hours" value={entryTimeInput.hours} onChange={handleEntryTimeChange}
                      placeholder="HH" min="1" max="12" className="w-16 px-3 py-2 border border-gray-300 rounded-md text-center" />
                    <span>:</span>
                    <input type="number" name="minutes" value={entryTimeInput.minutes} onChange={handleEntryTimeChange}
                      placeholder="MM" min="0" max="59" className="w-16 px-3 py-2 border border-gray-300 rounded-md text-center" />
                    <select name="period" value={entryTimeInput.period} onChange={handleEntryTimeChange}
                      className="w-20 px-2 py-2 border border-gray-300 rounded-md">
                      <option value="AM">AM</option>
                      <option value="PM">PM</option>
                    </select>
                  </div>
                </div>

                <div className="flex items-start mb-4">
                  <input type="checkbox" id="busEntry" checked={busEntry} onChange={(e) => setBusEntry(e.target.checked)}
                    className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded mt-1" />
                  <label htmlFor="busEntry" className="ml-2 block text-sm text-gray-700">Taken Factorykaam Bus Service</label>
                </div>

                {entryTimeError && (
                  <div className="bg-red-50 border border-red-200 text-red-700 px-3 py-2 rounded-md mb-4">
                    <div className="flex items-center">
                      <AlertCircle className="h-4 w-4 mr-2 flex-shrink-0" />
                      <span className="text-sm">{entryTimeError}</span>
                    </div>
                  </div>
                )}

                <button
                  onClick={handleEntryUpdate}
                  disabled={loading || !entryTimeInput.hours || !entryTimeInput.minutes || !entryDate}
                  className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 disabled:bg-indigo-300 flex items-center justify-center"
                >
                  {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Update Entry Time"}
                </button>
              </div>
            ) : (
              /* ── NEW ENTRY ── */
              <div className="mb-6">
                {/* Tabs */}
                <div className="flex border-b border-gray-200 mb-4">
                  <button
                    onClick={() => {
                      setSearchTab("phone");
                      setPhoneInput("");
                      setPhoneError("");
                      setWorkerError("");
                      resetWorkerState();
                    }}
                    className={`flex-1 py-2 text-sm font-medium transition-colors ${
                      searchTab === "phone"
                        ? "text-indigo-600 border-b-2 border-indigo-600"
                        : "text-gray-500 hover:text-gray-700"
                    }`}
                  >
                    Phone Number
                  </button>
                  <button
                    onClick={() => {
                      setSearchTab("emp");
                      setEmpCodeInput("");
                      setPhoneError("");
                      setWorkerError("");
                      resetWorkerState();
                    }}
                    className={`flex-1 py-2 text-sm font-medium transition-colors ${
                      searchTab === "emp"
                        ? "text-indigo-600 border-b-2 border-indigo-600"
                        : "text-gray-500 hover:text-gray-700"
                    }`}
                  >
                    Worker Code
                  </button>
                </div>

                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    {searchTab === "phone" ? "Phone Number" : "Worker Code"}
                  </label>
                  <div className="flex flex-col gap-2">
                    {searchTab === "phone" ? (
                      <input
                        type="text"
                        value={phoneInput}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^\d{0,10}$/.test(value)) {
                            setPhoneInput(value);
                            setPhoneError("");
                            setWorkerError("");
                            resetWorkerState();
                          }
                        }}
                        placeholder="Enter 10-digit phone number"
                        className="flex-1 px-3 py-2 text-sm border border-gray-300 rounded-md"
                      />
                    ) : (
                      <input
                        type="text"
                        value={empCodeInput}
                        onChange={(e) => {
                          setEmpCodeInput(e.target.value);
                          setPhoneError("");
                          setWorkerError("");
                          resetWorkerState();
                        }}
                        placeholder="Enter worker code (e.g., FAC0012323)"
                        className="flex-1 px-3 py-2 text-sm border border-gray-300 rounded-md"
                      />
                    )}

      <div className="flex justify-start">
        <button
          onClick={handleCheckPhone}
          disabled={
            searchTab === "phone"
              ? !phoneInput || phoneInput.length !== 10
              : !empCodeInput.trim()
          }
          className="px-3 py-2 bg-indigo-600 text-white text-sm rounded-md hover:bg-indigo-700 disabled:bg-indigo-300"
        >
          Check
        </button>
      </div>

      {phoneError && <div className="text-red-500 text-sm">{phoneError}</div>}
      {workerError && <div className="text-red-500 text-sm">{workerError}</div>}
    </div>
  </div>

  {workerDetails && (
    <>
      <div className="mb-4">
        <p className="text-sm text-gray-600">Worker Name: <span className="font-medium">{workerDetails.name}</span></p>
        <p className="text-sm text-gray-600">Skills: <span className="font-medium">{workerSkills}</span></p>
      </div>

                    <div className="mb-4">
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Department <span className="text-red-500">*</span>
                      </label>
                      <select
                        value={selectedEntryDepartment}
                        onChange={(e) => setSelectedEntryDepartment(e.target.value)}
                        className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md"
                      >
                        <option value="" disabled>
                          {mappedDepartments.length === 0
                            ? "No mapped departments"
                            : "Please select a department"}
                        </option>
                        {mappedDepartments.map((dept, index) => (
                          <option key={index} value={dept}>{dept}</option>
                        ))}
                      </select>
                    </div>

      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-700 mb-1">Entry Date</label>
        <CalendarInput value={entryDate} onChange={handleEntryDateChange} min={yesterday} max={today} />
      </div>

      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-700 mb-1">Entry Time</label>
        <div className="flex items-center gap-2">
          <input type="number" name="hours" value={entryTimeInput.hours} onChange={handleEntryTimeChange}
            placeholder="HH" min="1" max="12" className="w-16 px-3 py-2 border border-gray-300 rounded-md text-center" />
          <span>:</span>
          <input type="number" name="minutes" value={entryTimeInput.minutes} onChange={handleEntryTimeChange}
            placeholder="MM" min="0" max="59" className="w-16 px-3 py-2 border border-gray-300 rounded-md text-center" />
          <select name="period" value={entryTimeInput.period} onChange={handleEntryTimeChange}
            className="w-20 px-2 py-2 border border-gray-300 rounded-md">
            <option value="AM">AM</option>
            <option value="PM">PM</option>
          </select>
        </div>
      </div>

      <div className="flex items-start mb-4">
        <input type="checkbox" id="busEntryNew" checked={busEntry} onChange={(e) => setBusEntry(e.target.checked)}
          className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded mt-1" />
        <label htmlFor="busEntryNew" className="ml-2 block text-sm text-gray-700">Taken Factorykaam Bus Service</label>
      </div>

      {entryTimeError && (
        <div className="bg-red-50 border border-red-200 text-red-700 px-3 py-2 rounded-md mb-4">
          <div className="flex items-center">
            <AlertCircle className="h-4 w-4 mr-2 flex-shrink-0" />
            <span className="text-sm">{entryTimeError}</span>
          </div>
        </div>
      )}

                    <button
                      onClick={handleEntrySubmit}
                      disabled={
                        loading ||
                        !selectedEntryDepartment ||
                        !entryTimeInput.hours ||
                        !entryTimeInput.minutes ||
                        !entryDate
                      }
                      className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 disabled:bg-indigo-300 flex items-center justify-center"
                    >
                      {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Mark Entry Time"}
                    </button>
                  </>
                )}
              </div>
            )}
          </div>
        </div>
      )}

      {/* Success Modal — outside showEntryModal gate so it persists after modal closes */}
      {showSuccessModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1100]">
          <div className="bg-white rounded-lg p-6 max-w-sm w-full mx-4">
            <div className="flex flex-col items-center text-center">
              <CheckCircle2 className="h-12 w-12 text-green-500 mb-4" />
              <h3 className="text-lg font-semibold mb-2">Success!</h3>
              <p className="text-gray-600 mb-6">{errorMessage}</p>
              <button onClick={() => setShowSuccessModal(false)} className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700">OK</button>
            </div>
          </div>
        </div>
      )}

      {/* Error Modal — outside showEntryModal gate so it persists after modal closes */}
      {showErrorModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1100]">
          <div className="bg-white rounded-lg p-6 max-w-sm w-full mx-4">
            <div className="flex flex-col items-center text-center">
              <AlertCircle className="h-12 w-12 text-red-500 mb-4" />
              <h3 className="text-lg font-semibold mb-2">Error</h3>
              <p className="text-gray-600 mb-6">{errorMessage}</p>
              <button onClick={() => setShowErrorModal(false)} className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700">OK</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default HandleEntry;